import {createSlice} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';

const initialState = {
  port: null,
  signupToken: null,
  subscriptionsAvailable: [],
  trialData: {},
  payluxData: {},
  keyData: {},
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setPortNumber: (state, action) => {
      state.port = action.payload;
    },
    setSignupToken: (state, action) => {
      state.signupToken = action.payload;
    },
    setSubscriptionsAvailable: (state, action) => {
      state.subscriptionsAvailable = action.payload;
      state.subscriptionsAvailable.forEach(sub => {
        if (sub.PaymentService === 'trial') {
          state.trialData = sub;
        } else if (sub.PaymentService === 'paylux') {
          state.payluxData = sub;
        } else if (sub.PaymentService === 'key') {
          state.keyData = sub;
        } else {
          console.log('subscription data not set');
        }
      });
    },
  },
});

export const {setPortNumber, setSignupToken, setSubscriptionsAvailable} = appSlice.actions;

export default appSlice.reducer;
